var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6463 3.63484C21.2246 2.29211 18.9364 2.29211 14.36 2.29211H13.1465C8.57009 2.29211 6.28189 2.29211 4.86018 3.63484C3.43848 4.97756 3.43848 7.13863 3.43848 11.4608V16.0451C3.43848 20.3673 3.43848 22.5284 4.86018 23.8711C6.28189 25.2138 8.57009 25.2138 13.1465 25.2138H14.36C16.3026 25.2138 17.833 25.2138 19.0597 25.1111L20.0567 21.3051C19.029 20.7116 18.3376 19.6023 18.3376 18.3317C18.3376 16.4359 19.8769 14.899 21.7758 14.899C22.6564 14.899 23.4597 15.2296 24.068 15.7731V11.4608C24.068 7.13863 24.068 4.97756 22.6463 3.63484Z",
    fill: "url(#paint0_linear_4930_7623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4209 1.4325H13.084C10.8481 1.43248 9.08721 1.43247 7.71126 1.60718C6.30275 1.78603 5.16787 2.16112 4.2692 3.00987C3.36359 3.86517 2.95703 4.95633 2.76442 6.30933C2.57809 7.61824 2.5781 9.28936 2.57813 11.3927V16.1131C2.5781 18.2164 2.57809 19.8876 2.76442 21.1965C2.95702 22.5495 3.36359 23.6406 4.2692 24.4959C5.16787 25.3447 6.30275 25.7198 7.71126 25.8986C9.08721 26.0733 10.8481 26.0733 13.084 26.0733H13.1457L13.1626 26.0731L13.1794 26.0733H14.8985C15.3733 26.0733 15.7581 25.6885 15.7581 25.2137C15.7581 24.739 15.3733 24.3542 14.8985 24.3542H13.1794L13.1626 24.3543L13.1457 24.3542C10.8345 24.3542 9.18285 24.3525 7.92781 24.1932C6.6927 24.0364 5.97262 23.7401 5.44959 23.2461C4.9335 22.7587 4.62921 22.098 4.46639 20.9542C4.29929 19.7804 4.29725 18.2318 4.29725 16.0451L4.29725 11.4607C4.29725 9.27397 4.2993 7.72538 4.46639 6.55161C4.62921 5.40785 4.9335 4.74712 5.44959 4.25969C5.97262 3.76572 6.6927 3.46945 7.92781 3.31262C9.18286 3.15325 10.8345 3.15162 13.1457 3.15162H14.3592C16.6704 3.15162 18.322 3.15325 19.5771 3.31262C20.8122 3.46945 21.5323 3.76572 22.0553 4.25969C22.5714 4.74712 22.8757 5.40785 23.0385 6.55161C23.2056 7.72538 23.2076 9.27397 23.2076 11.4607C23.2076 11.9355 23.5925 12.3203 24.0672 12.3203C24.5419 12.3203 24.9268 11.9355 24.9268 11.4607V11.3928C24.9268 9.28938 24.9268 7.61825 24.7405 6.30933C24.5479 4.95633 24.1413 3.86517 23.2357 3.00987C22.337 2.16112 21.2021 1.78603 19.7936 1.60718C18.4177 1.43247 16.6568 1.43248 14.4209 1.4325Z",
    fill: "url(#paint1_linear_4930_7623)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16811 7.16292C8.69339 7.16292 8.30855 7.54776 8.30855 8.02248C8.30855 8.4972 8.69339 8.88204 9.16811 8.88204H18.3368C18.8115 8.88204 19.1963 8.4972 19.1963 8.02248C19.1963 7.54776 18.8115 7.16292 18.3368 7.16292H9.16811Z",
    fill: "url(#paint2_linear_4930_7623)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30855 13.7529C8.30855 13.2782 8.69339 12.8933 9.16811 12.8933H14.8985C15.3733 12.8933 15.7581 13.2782 15.7581 13.7529C15.7581 14.2276 15.3733 14.6125 14.8985 14.6125H9.16811C8.69339 14.6125 8.30855 14.2276 8.30855 13.7529Z",
    fill: "url(#paint3_linear_4930_7623)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.775 14.0394C19.4027 14.0394 17.4772 15.9598 17.4772 18.3317C17.4772 19.6745 18.0944 20.8726 19.0605 21.6595L18.1956 24.6826L18.1894 24.7053C17.9671 25.5712 18.8234 26.3158 19.6479 25.9866L21.775 25.1371L23.9239 25.9952C24.7285 26.3165 25.573 25.6137 25.3933 24.7603L25.3891 24.7417L24.6386 21.5324C25.5187 20.7466 26.0729 19.6041 26.0729 18.3317C26.0729 15.9598 24.1473 14.0394 21.775 14.0394ZM19.1963 18.3317C19.1963 16.9119 20.3495 15.7585 21.775 15.7585C23.2005 15.7585 24.3537 16.9119 24.3537 18.3317C24.3537 19.7514 23.2005 20.9048 21.775 20.9048C20.3495 20.9048 19.1963 19.7514 19.1963 18.3317ZM20.2037 23.9135L20.6177 22.4664C20.986 22.569 21.3741 22.6239 21.775 22.6239C22.2303 22.6239 22.6692 22.5531 23.0811 22.422L23.4385 23.9503L22.2641 23.4813C21.9501 23.3559 21.6 23.3559 21.286 23.4813L20.2037 23.9135Z",
    fill: "url(#paint4_linear_4930_7623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_7623",
    x1: 13.7532,
    y1: 2.29211,
    x2: 13.7532,
    y2: 25.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4930_7623",
    x1: 14.3255,
    y1: 1.4325,
    x2: 14.3255,
    y2: 26.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4930_7623",
    x1: 14.3255,
    y1: 1.4325,
    x2: 14.3255,
    y2: 26.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4930_7623",
    x1: 14.3255,
    y1: 1.4325,
    x2: 14.3255,
    y2: 26.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4930_7623",
    x1: 14.3255,
    y1: 1.4325,
    x2: 14.3255,
    y2: 26.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.51f6d5ea70b60c50a2d07386c98a8da3.svg";
export { ForwardRef as ReactComponent };